export default __webpack_public_path__ + "static/media/inventronics.d767e92d.png";